import api from './api';

export const getCanteenSettings = () => api.get('/v1/canteen-settings');
export const updateCanteenSettings = (data) => api.put('/v1/canteen-settings', data);
